"use strict";
var sidebar_1 = require("./sidebar/sidebar");
var groups_1 = require("./groups/groups");
var assign_programs_1 = require("./assign-programs/assign-programs");
var breadcrumbs_1 = require("./common/breadcrumbs/breadcrumbs");
var paginator_1 = require("./common/paginator/paginator");
var group_detail_1 = require("./group-detail/group-detail");
var default_group_detail_1 = require("./group-detail/default-group-detail");
var manage_defaults_1 = require("./manage-defaults/manage-defaults");
var toggle_1 = require("./common/toggle/toggle");
var modal_window_1 = require("./common/modal-window/modal-window");
var set_ap_programs_1 = require("./set-ap-programs/set-ap-programs");
function initComponents(app) {
    app.directive("sidebar", function () { return sidebar_1.sidebar; });
    app.directive("breadcrumbs", function () { return breadcrumbs_1.breadcrumbs; });
    app.component("groups", groups_1.groups);
    app.component("assignPrograms", assign_programs_1.assignPrograms);
    app.directive("paginator", function () { return paginator_1.paginator; });
    app.component("groupDetail", group_detail_1.groupDetail);
    app.component("defaultGroupDetail", default_group_detail_1.defaultGroupDetail);
    app.directive("manageDefaults", function () { return manage_defaults_1.manageDefaults; });
    app.component("toggle", toggle_1.toggle);
    app.directive("modalWindow", function () { return modal_window_1.modalWindow; });
    app.directive("setApPrograms", function () { return set_ap_programs_1.setApPrograms; });
}
exports.initComponents = initComponents;



/** WEBPACK FOOTER **
 ** ./app/app.components.ts
 **/